import constants from "./constants"

export const actions = {
    getSurvey: (surveyKey, stayGuid) => {
        return { type: constants.GET_SURVEY, surveyKey, stayGuid }
    },
    getSurveySuccess: (data) => {
        return { type: constants.GET_SURVEY_SUCCESS, data }
    },
    GetSurveyFailed: (error) => {
        return { type: constants.GET_SURVEY_FAILED, error }
    },
    updateAnswer: (questionId, answerId, value) => {
        return { type: constants.UPDATE_ANSWER, questionId, answerId, value }
    },
    sendSurveyResponse: (surveyResponse) => {
        return { type: constants.SEND_SURVEY_RESULT, surveyResponse }
    },
    sendSurveyResponseSuccess: (data) => {
        return { type: constants.SEND_SURVEY_RESULT_SUCCESS, data }
    },
    sendSurveyResponseFailed: (error) => {
        return { type: constants.SEND_SURVEY_RESULT_FAILED, error }
    },
    setUrlData: (surveyKey, stayGuid) => {
        return { type: constants.SET_URL_DATA, surveyKey, stayGuid }
    }

}